import {
  copyOf2ng0t8oizk6it as copyOf,
  IndexOutOfBoundsException1qfr429iumro0 as IndexOutOfBoundsException,
  NoSuchElementException679xzhnp5bpj as NoSuchElementException,
  getOrNull1d60i0672n7ns as getOrNull,
  fill3hcjvebk42tyx as fill,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  VOID7hggqo3abtya as VOID,
  longArray288a0fctlmjmj as longArray,
  Long2qws0ah9gnpki as Long,
  copyOf9mbsebmgnw4t as copyOf_0,
  Unit_instanceat14thlj150z as Unit_instance,
  countLeadingZeroBits1tnrq8lk0emwh as countLeadingZeroBits,
  StringBuildermazzzhj6kkai as StringBuilder,
  _Char___init__impl__6a9atx367vrx0avsvbg as _Char___init__impl__6a9atx,
  charArrayOf27f4r3dozbrk1 as charArrayOf,
  trimEndvvzjdhan75g as trimEnd,
  isBlank1dvkhjjvox3p0 as isBlank,
  fillArrayVali8eppxapiek4 as fillArrayVal,
  arrayCopytctsywo3h7gj as arrayCopy,
  getKClassFromExpression3vpejubogshaw as getKClassFromExpression,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  contentHashCode2i020q5tbeh2s as contentHashCode,
  equals2au1ep9vhcato as equals,
  FunctionAdapter3lcrrz3moet5b as FunctionAdapter,
  isInterface3d6p8outrmvmk as isInterface,
  Comparator2b3maoeh98xtg as Comparator,
  hashCodeq5arwsb9dgti as hashCode,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  getKClass1s3j9wy1cofik as getKClass,
  LazyThreadSafetyMode_PUBLICATION_getInstance23f213579at67 as LazyThreadSafetyMode_PUBLICATION_getInstance,
  lazy1261dae0bgscp as lazy,
  throwUninitializedPropertyAccessExceptionyynx7gkm73wd as throwUninitializedPropertyAccessException,
  toString1pkumu07cwy4m as toString,
  substringAfterLastuw9v7gfiiihe as substringAfterLast,
  substringBeforekje8w2lxhyb6 as substringBefore,
  _UInt___init__impl__l7qpdl2x2ja0qtrydmg as _UInt___init__impl__l7qpdl,
  UInt1hthisrv6cndi as UInt,
  protoOf180f3jzyo7rfj as protoOf,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  UInt__hashCode_impl_z2mhuw2hl6ws6qmi0af as UInt__hashCode_impl_z2mhuw,
  createThis2j2avj17cvnv2 as createThis,
  Collection1k04j3hzsbod0 as Collection,
  ArrayDeque2dzc9uld4xi7n as ArrayDeque,
  _UInt___get_data__impl__f0vqqw1wfqgh301wggv as _UInt___get_data__impl__f0vqqw,
  captureStack1fzi4aczwc4hg as captureStack,
  RuntimeException1r3t0zl97011n as RuntimeException,
  toString30pk9tzaqopn as toString_0,
  getNumberHashCode2l4nbdcihl25f as getNumberHashCode,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  ArrayList3it5z8td81qkl as ArrayList,
  get_lastIndex1yw0x4k50k51w as get_lastIndex,
  LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap,
  KtList3hktaavzmj137 as KtList,
  collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault,
  mapCapacity1h45rc3eh9p2l as mapCapacity,
  coerceAtLeast2bkz8m9ik7hep as coerceAtLeast,
  compareTo3ankvs086tmwq as compareTo,
  KtMap140uvy3s5zad8 as KtMap,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
} from './kotlin-kotlin-stdlib.mjs';
import {
  PolymorphicSerializer3p3fzpdobi8hh as PolymorphicSerializer,
  SerializerFactory1qv9hivitncuv as SerializerFactory,
  PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor,
  UIntSerializer_getInstance1f4j3hi6ln6i8 as UIntSerializer_getInstance,
  UnknownFieldExceptiona60e3a6v1xqo as UnknownFieldException,
  IntSerializer_getInstance3jjhuzya8j8kz as IntSerializer_getInstance,
  typeParametersSerializers2likxjr48tr7y as typeParametersSerializers,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
  throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException,
  ArrayListSerializer7k5wnrulb3y6 as ArrayListSerializer,
} from './kotlinx-serialization-kotlinx-serialization-core.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
class Bag {
  constructor(values) {
    this.e1s_1 = values;
    this.f1s_1 = 0;
  }
  g1s() {
    return this.e1s_1.length;
  }
  h1s(index, value) {
    if (index >= this.e1s_1.length) {
      var tmp = this;
      var tmp_0 = this.e1s_1;
      // Inline function 'kotlin.math.max' call
      var a = imul(this.f1s_1, 2);
      var b = index + 1 | 0;
      var tmp$ret$0 = Math.max(a, b);
      tmp.e1s_1 = copyOf(tmp_0, tmp$ret$0);
    }
    var tmp_1 = this;
    // Inline function 'kotlin.math.max' call
    var a_0 = this.f1s_1;
    var b_0 = index + 1 | 0;
    tmp_1.f1s_1 = Math.max(a_0, b_0);
    this.e1s_1[index] = value;
  }
  h1(index) {
    if (index < 0 || index >= this.f1s_1)
      throw IndexOutOfBoundsException.ze('' + index + ' is not valid for bag of size ' + this.f1s_1);
    var tmp0_elvis_lhs = this.e1s_1[index];
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw NoSuchElementException.p('Bag has no value at index ' + index);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  i1s(index) {
    return getOrNull(this.e1s_1, index);
  }
  j1s(index) {
    return index >= this.f1s_1 || index < 0 || this.e1s_1[index] == null;
  }
  k1s(index) {
    return (0 <= index ? index < this.f1s_1 : false) && !(this.e1s_1[index] == null);
  }
  l1s(index) {
    this.e1s_1[index] = null;
  }
  h3() {
    fill(this.e1s_1, null);
    this.f1s_1 = 0;
  }
}
class BitArray {
  constructor(nBits) {
    nBits = nBits === VOID ? 0 : nBits;
    this.m1s_1 = longArray((nBits + 63 | 0) >>> 6 | 0);
  }
  n1s() {
    var inductionVariable = this.m1s_1.length - 1 | 0;
    if (0 <= inductionVariable)
      do {
        var word = inductionVariable;
        inductionVariable = inductionVariable + -1 | 0;
        if (!this.m1s_1[word].equals(new Long(0, 0))) {
          return true;
        }
      }
       while (0 <= inductionVariable);
    return false;
  }
  o1s() {
    return !this.n1s();
  }
  h1(idx) {
    var word = idx >>> 6 | 0;
    return word < this.m1s_1.length && !this.m1s_1[word].h4((new Long(1, 0)).e4(idx)).equals(new Long(0, 0));
  }
  p1s(idx) {
    var word = idx >>> 6 | 0;
    if (word >= this.m1s_1.length) {
      this.m1s_1 = copyOf_0(this.m1s_1, (word + word | 0) - ~((word | (-word | 0)) >> 63) | 0);
    }
    this.m1s_1[word] = this.m1s_1[word].i4((new Long(1, 0)).e4(idx));
  }
  q1s(idx) {
    var word = idx >>> 6 | 0;
    if (word < this.m1s_1.length) {
      this.m1s_1[word] = this.m1s_1[word].h4((new Long(1, 0)).e4(idx).d4());
    }
  }
  r1s(other) {
    var otherBits = other.m1s_1;
    // Inline function 'kotlin.math.min' call
    var a = this.m1s_1.length;
    var b = otherBits.length;
    var start = Math.min(a, b) - 1 | 0;
    var inductionVariable = start;
    if (0 <= inductionVariable)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + -1 | 0;
        if (!this.m1s_1[i].h4(otherBits[i]).equals(new Long(0, 0))) {
          return true;
        }
      }
       while (0 <= inductionVariable);
    return false;
  }
  s1s(other) {
    var otherBits = other.m1s_1;
    var inductionVariable = this.m1s_1.length;
    var last = otherBits.length;
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!otherBits[i].equals(new Long(0, 0))) {
          return false;
        }
      }
       while (inductionVariable < last);
    // Inline function 'kotlin.math.min' call
    var a = this.m1s_1.length;
    var b = otherBits.length;
    var start = Math.min(a, b) - 1 | 0;
    var inductionVariable_0 = start;
    if (0 <= inductionVariable_0)
      do {
        var i_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + -1 | 0;
        if (!this.m1s_1[i_0].h4(otherBits[i_0]).equals(otherBits[i_0])) {
          return false;
        }
      }
       while (0 <= inductionVariable_0);
    return true;
  }
  t1s() {
    var inductionVariable = this.m1s_1.length - 1 | 0;
    if (0 <= inductionVariable)
      do {
        var word = inductionVariable;
        inductionVariable = inductionVariable + -1 | 0;
        var bitsAtWord = this.m1s_1[word];
        if (!bitsAtWord.equals(new Long(0, 0))) {
          var w = word << 6;
          return w + (64 - countLeadingZeroBits(bitsAtWord) | 0) | 0;
        }
      }
       while (0 <= inductionVariable);
    return 0;
  }
  hashCode() {
    // Inline function 'kotlin.collections.isEmpty' call
    if (this.m1s_1.length === 0) {
      return 0;
    }
    var word = this.t1s() >>> 6 | 0;
    var hash = 0;
    var inductionVariable = 0;
    if (inductionVariable <= word)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        hash = imul(127, hash) + this.m1s_1[i].j4(this.m1s_1[i].g4(32)).l2() | 0;
      }
       while (!(i === word));
    return hash;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BitArray))
      return false;
    var otherBits = other.m1s_1;
    // Inline function 'kotlin.math.min' call
    var a = this.m1s_1.length;
    var b = otherBits.length;
    var commonWords = Math.min(a, b);
    var inductionVariable = 0;
    if (inductionVariable < commonWords)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!this.m1s_1[i].equals(otherBits[i]))
          return false;
      }
       while (inductionVariable < commonWords);
    return this.m1s_1.length === otherBits.length ? true : this.t1s() === other.t1s();
  }
  toString() {
    // Inline function 'kotlin.text.ifBlank' call
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.f();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.github.quillraven.fleks.collection.BitArray.toString.<anonymous>' call
    var indexedObject = this.m1s_1;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var bitsAtWord = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (!bitsAtWord.equals(new Long(0, 0))) {
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < 64)
          do {
            var bit = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            if (!bitsAtWord.h4((new Long(1, 0)).e4(bit)).equals(new Long(0, 0))) {
              this_0.gc('1');
            } else {
              this_0.gc('0');
            }
          }
           while (inductionVariable_0 < 64);
      } else {
        // Inline function 'kotlin.repeat' call
        // Inline function 'kotlin.contracts.contract' call
        var inductionVariable_1 = 0;
        if (inductionVariable_1 < 64)
          do {
            var index = inductionVariable_1;
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            // Inline function 'com.github.quillraven.fleks.collection.BitArray.toString.<anonymous>.<anonymous>' call
            this_0.gc('0');
          }
           while (inductionVariable_1 < 64);
      }
    }
    var tmp$ret$1 = this_0.toString();
    var this_1 = trimEnd(tmp$ret$1, charArrayOf([_Char___init__impl__6a9atx(48)]));
    // Inline function 'kotlin.contracts.contract' call
    var tmp;
    if (isBlank(this_1)) {
      // Inline function 'com.github.quillraven.fleks.collection.BitArray.toString.<anonymous>' call
      tmp = '0';
    } else {
      tmp = this_1;
    }
    return tmp;
  }
}
class MutableEntityBag {
  constructor(size) {
    size = size === VOID ? 64 : size;
    var tmp = this;
    var tmp_0 = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_1 = fillArrayVal(Array(size), null);
    while (tmp_0 < size) {
      tmp_1[tmp_0] = Companion_getInstance_1().x1s_1;
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp.u1s_1 = tmp_1;
    this.v1s_1 = 0;
  }
  y1s(entity) {
    if (this.v1s_1 === this.u1s_1.length) {
      var tmp = this;
      // Inline function 'kotlin.collections.copyInto' call
      var this_0 = this.u1s_1;
      var tmp_0 = 0;
      // Inline function 'kotlin.math.max' call
      var b = imul(this.v1s_1, 2);
      var tmp_1 = Math.max(1, b);
      // Inline function 'kotlin.arrayOfNulls' call
      var tmp_2 = fillArrayVal(Array(tmp_1), null);
      while (tmp_0 < tmp_1) {
        tmp_2[tmp_0] = Companion_getInstance_1().x1s_1;
        tmp_0 = tmp_0 + 1 | 0;
      }
      var endIndex = this_0.length;
      arrayCopy(this_0, tmp_2, 0, 0, endIndex);
      tmp.u1s_1 = tmp_2;
    }
    var tmp_3 = this.u1s_1;
    var _unary__edvuaz = this.v1s_1;
    this.v1s_1 = _unary__edvuaz + 1 | 0;
    tmp_3[_unary__edvuaz] = entity;
  }
  h3() {
    fill(this.u1s_1, Companion_getInstance_1().x1s_1);
    this.v1s_1 = 0;
  }
  z1s(capacity) {
    if (capacity > this.u1s_1.length) {
      var tmp = this;
      var tmp_0 = 0;
      var tmp_1 = capacity + 1 | 0;
      // Inline function 'kotlin.arrayOfNulls' call
      var tmp_2 = fillArrayVal(Array(tmp_1), null);
      while (tmp_0 < tmp_1) {
        tmp_2[tmp_0] = Companion_getInstance_1().x1s_1;
        tmp_0 = tmp_0 + 1 | 0;
      }
      tmp.u1s_1 = tmp_2;
    } else {
      fill(this.u1s_1, Companion_getInstance_1().x1s_1);
    }
    this.v1s_1 = 0;
  }
  a1t(comparator) {
    quickSort(this.u1s_1, 0, this.v1s_1, comparator);
  }
  w1s(entity) {
    var inductionVariable = 0;
    var last = this.v1s_1;
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (this.u1s_1[i].equals(entity)) {
          return true;
        }
      }
       while (inductionVariable < last);
    return false;
  }
  b1t(entities) {
    return entities.c1t(MutableEntityBag$containsAll$lambda(this));
  }
  j1() {
    return this.v1s_1 === 0;
  }
  d1t() {
    return this.v1s_1 > 0;
  }
  c1t(predicate) {
    var inductionVariable = 0;
    var last = this.v1s_1;
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!predicate(this.u1s_1[i])) {
          return false;
        }
      }
       while (inductionVariable < last);
    return true;
  }
  nl() {
    if (this.j1()) {
      return null;
    }
    return this.u1s_1[0];
  }
  equals(other) {
    if (this === other)
      return true;
    if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
      return false;
    if (!(other instanceof MutableEntityBag))
      THROW_CCE();
    if (!(this.v1s_1 === other.v1s_1))
      return false;
    return this.b1t(other);
  }
  hashCode() {
    var result = contentHashCode(this.u1s_1);
    result = imul(31, result) + this.v1s_1 | 0;
    return result;
  }
}
class sam$kotlin_Comparator$0 {
  constructor(function_0) {
    this.k1t_1 = function_0;
  }
  vj(a, b) {
    return this.k1t_1(a, b);
  }
  compare(a, b) {
    return this.vj(a, b);
  }
  o4() {
    return this.k1t_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Comparator) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.o4(), other.o4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.o4());
  }
}
class Companion {
  constructor() {
    this.l1t_1 = 0;
  }
}
class UniqueId {}
class Companion_0 {
  constructor() {
    Companion_instance_0 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.n1t_1 = lazy(tmp_0, ComponentType$Companion$_anonymous__95jk5k);
  }
  o1t(typeSerial0) {
    return _get_$cachedSerializer__te6jhj(this);
  }
  r17(typeParamsSerializers) {
    return this.o1t(typeParamsSerializers[0]);
  }
}
class ComponentType {
  constructor() {
    Companion_getInstance_0();
    var tmp = this;
    var _unary__edvuaz = Companion_instance.l1t_1;
    Companion_instance.l1t_1 = _unary__edvuaz + 1 | 0;
    tmp.p1t_1 = _unary__edvuaz;
  }
  m1t() {
    return this.p1t_1;
  }
}
class Component {}
function onAdd(_this__u8e3s4, entity) {
  return Unit_instance;
}
function onRemove(_this__u8e3s4, entity) {
  return Unit_instance;
}
class ComponentService {
  constructor() {
    var tmp = this;
    // Inline function 'com.github.quillraven.fleks.collection.bag' call
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp$ret$0 = fillArrayVal(Array(64), null);
    tmp.u1t_1 = new Bag(tmp$ret$0);
  }
  v1t() {
    var tmp = this.t1t_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('world');
    }
  }
  w1t(componentType) {
    if (this.u1t_1.j1s(componentType.m1t())) {
      var tmp = componentType.m1t();
      var tmp_0 = this.v1t();
      var tmp_1 = 0;
      var tmp_2 = this.v1t().g1s();
      // Inline function 'kotlin.arrayOfNulls' call
      var tmp_3 = fillArrayVal(Array(tmp_2), null);
      while (tmp_1 < tmp_2) {
        tmp_3[tmp_1] = null;
        tmp_1 = tmp_1 + 1 | 0;
      }
      this.u1t_1.h1s(tmp, new ComponentsHolder(tmp_0, componentType, tmp_3));
    }
    return this.u1t_1.h1(componentType.m1t());
  }
  g1u(index) {
    return this.u1t_1.i1s(index);
  }
}
class ComponentsHolder {
  constructor(world, type, components) {
    this.h1u_1 = world;
    this.i1u_1 = type;
    this.j1u_1 = components;
  }
  k1u(entity, component) {
    return this.l1u(entity, isInterface(component, Component) ? component : THROW_CCE());
  }
  l1u(entity, component) {
    if (entity.m1u_1 >= this.j1u_1.length) {
      var tmp = this;
      var tmp_0 = this.j1u_1;
      // Inline function 'kotlin.math.max' call
      var a = imul(this.j1u_1.length, 2);
      var b = entity.m1u_1 + 1 | 0;
      var tmp$ret$0 = Math.max(a, b);
      tmp.j1u_1 = copyOf(tmp_0, tmp$ret$0);
    }
    var tmp0_safe_receiver = this.j1u_1[entity.m1u_1];
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.run' call
      // Inline function 'kotlin.contracts.contract' call
      this.j1u_1[entity.m1u_1] = null;
      tmp0_safe_receiver.s1t(this.h1u_1, entity);
    }
    this.j1u_1[entity.m1u_1] = component;
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    component.r1t(this.h1u_1, entity);
  }
  o1u(entity) {
    if (entity.m1u_1 < 0 || entity.m1u_1 >= this.j1u_1.length)
      throw IndexOutOfBoundsException.ze(entity.toString() + '.id is not valid for components of size ' + this.j1u_1.length);
    var existingCmp = this.j1u_1[entity.m1u_1];
    this.j1u_1[entity.m1u_1] = null;
    if (existingCmp == null)
      null;
    else {
      // Inline function 'kotlin.run' call
      // Inline function 'kotlin.contracts.contract' call
      existingCmp.s1t(this.h1u_1, entity);
    }
  }
  p1u(entity) {
    var tmp0_elvis_lhs = this.j1u_1[entity.m1u_1];
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw FleksNoSuchEntityComponentException.u1u(entity, componentName(this));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  v1u(entity) {
    return getOrNull(this.j1u_1, entity.m1u_1);
  }
  toString() {
    return 'ComponentsHolder(type=' + componentName(this) + ', id=' + this.i1u_1.m1t() + ')';
  }
}
class entityTagOf$1 extends ComponentType {}
class Companion_1 {
  constructor() {
    Companion_instance_1 = this;
    this.x1s_1 = new Entity(-1, _UInt___init__impl__l7qpdl(0));
  }
}
class $serializer {
  constructor() {
    $serializer_instance = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.github.quillraven.fleks.Entity', this, 2);
    tmp0_serialDesc.m16('id', false);
    tmp0_serialDesc.m16('version', false);
    this.w1u_1 = tmp0_serialDesc;
  }
  x1u(encoder, value) {
    var tmp0_desc = this.w1u_1;
    var tmp1_output = encoder.xy(tmp0_desc);
    tmp1_output.i10(tmp0_desc, 0, value.m1u_1);
    tmp1_output.p10(tmp0_desc, 1, UIntSerializer_getInstance(), new UInt(value.n1u_1));
    tmp1_output.yy(tmp0_desc);
  }
  zu(encoder, value) {
    return this.x1u(encoder, value instanceof Entity ? value : THROW_CCE());
  }
  av(decoder) {
    var tmp0_desc = this.w1u_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_local1 = null;
    var tmp6_input = decoder.xy(tmp0_desc);
    if (tmp6_input.nz()) {
      tmp4_local0 = tmp6_input.cz(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      var tmp = UIntSerializer_getInstance();
      var tmp_0 = tmp5_local1;
      var tmp_1 = tmp6_input.jz(tmp0_desc, 1, tmp, tmp_0 == null ? null : new UInt(tmp_0));
      tmp5_local1 = tmp_1 == null ? null : tmp_1.yt_1;
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.oz(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.cz(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            var tmp_2 = UIntSerializer_getInstance();
            var tmp_3 = tmp5_local1;
            var tmp_4 = tmp6_input.jz(tmp0_desc, 1, tmp_2, tmp_3 == null ? null : new UInt(tmp_3));
            tmp5_local1 = tmp_4 == null ? null : tmp_4.yt_1;
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.iw(tmp2_index);
        }
      }
    tmp6_input.yy(tmp0_desc);
    return Entity.y1u(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  yu() {
    return this.w1u_1;
  }
  d17() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance(), UIntSerializer_getInstance()];
  }
}
class Entity {
  constructor(id, version) {
    Companion_getInstance_1();
    this.m1u_1 = id;
    this.n1u_1 = version;
  }
  z1u(id, version) {
    return new Entity(id, version);
  }
  a1v(id, version, $super) {
    id = id === VOID ? this.m1u_1 : id;
    version = version === VOID ? this.n1u_1 : version;
    return $super === VOID ? this.z1u(id, version) : $super.z1u.call(this, id, new UInt(version));
  }
  toString() {
    return 'Entity(id=' + this.m1u_1 + ', version=' + new UInt(this.n1u_1) + ')';
  }
  hashCode() {
    var result = this.m1u_1;
    result = imul(result, 31) + UInt__hashCode_impl_z2mhuw(this.n1u_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Entity))
      return false;
    var tmp0_other_with_cast = other instanceof Entity ? other : THROW_CCE();
    if (!(this.m1u_1 === tmp0_other_with_cast.m1u_1))
      return false;
    if (!(this.n1u_1 === tmp0_other_with_cast.n1u_1))
      return false;
    return true;
  }
  static y1u(seen0, id, version, serializationConstructorMarker) {
    Companion_getInstance_1();
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance().w1u_1);
    }
    var $this = createThis(this);
    $this.m1u_1 = id;
    $this.n1u_1 = version;
    return $this;
  }
}
class EntityComponentContext {
  static j1v(componentService) {
    var $this = createThis(this);
    $this.i1v_1 = componentService;
    return $this;
  }
  k1v(_this__u8e3s4, type) {
    var tmp0_safe_receiver = this.i1v_1.v1t().a1u_1.o1v_1.i1s(_this__u8e3s4.m1u_1);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.h1(type.m1t());
    return tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
  }
}
class EntityCreateContext extends EntityComponentContext {
  static g1v(compService, compMasks) {
    var $this = this.j1v(compService);
    $this.f1v_1 = compMasks;
    return $this;
  }
  h1v(_this__u8e3s4, tag) {
    this.f1v_1.h1(_this__u8e3s4.m1u_1).p1s(tag.m1t());
    // Inline function 'kotlin.collections.set' call
    var this_0 = this.i1v_1.v1t().f1u_1;
    var key = tag.m1t();
    this_0.k3(key, tag);
  }
}
class EntityUpdateContext extends EntityCreateContext {
  static d1v(compService, compMasks) {
    return this.g1v(compService, compMasks);
  }
}
class EntityService {
  constructor(world, initialEntityCapacity, entityProvider, compService) {
    entityProvider = entityProvider === VOID ? new DefaultEntityProvider(world, initialEntityCapacity) : entityProvider;
    compService = compService === VOID ? world.i1v_1 : compService;
    this.l1v_1 = world;
    this.m1v_1 = entityProvider;
    this.n1v_1 = compService;
    var tmp = this;
    // Inline function 'com.github.quillraven.fleks.collection.bag' call
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp$ret$0 = fillArrayVal(Array(initialEntityCapacity), null);
    tmp.o1v_1 = new Bag(tmp$ret$0);
    this.p1v_1 = EntityCreateContext.g1v(this.n1v_1, this.o1v_1);
    this.q1v_1 = -1;
    this.r1v_1 = EntityUpdateContext.d1v(this.n1v_1, this.o1v_1);
    this.s1v_1 = -1;
    this.t1v_1 = false;
    this.u1v_1 = new MutableEntityBag();
    this.v1v_1 = null;
    this.w1v_1 = null;
  }
  x1v() {
    return this.m1v_1.y1v();
  }
  g1s() {
    return this.o1v_1.g1s();
  }
  z1v(entity, snapshot) {
    var compMask = this.o1v_1.h1(entity.m1u_1);
    var components = snapshot.a1w_1;
    // Inline function 'com.github.quillraven.fleks.collection.BitArray.clearAndForEachSetBit' call
    var inductionVariable = compMask.m1s_1.length - 1 | 0;
    if (0 <= inductionVariable)
      do {
        var word = inductionVariable;
        inductionVariable = inductionVariable + -1 | 0;
        var bitsAtWord = compMask.m1s_1[word];
        if (!bitsAtWord.equals(new Long(0, 0))) {
          var w = word << 6;
          while (!bitsAtWord.equals(new Long(0, 0))) {
            compMask.m1s_1[word] = new Long(0, 0);
            var bit = 63 - countLeadingZeroBits(bitsAtWord) | 0;
            $l$block_1: {
              // Inline function 'com.github.quillraven.fleks.EntityService.configure.<anonymous>' call
              var cmpId = w + bit | 0;
              var tmp$ret$0;
              $l$block_0: {
                // Inline function 'kotlin.collections.any' call
                var tmp;
                if (isInterface(components, Collection)) {
                  tmp = components.j1();
                } else {
                  tmp = false;
                }
                if (tmp) {
                  tmp$ret$0 = false;
                  break $l$block_0;
                }
                var tmp0_iterator = components.b1();
                while (tmp0_iterator.c1()) {
                  var element = tmp0_iterator.d1();
                  // Inline function 'com.github.quillraven.fleks.EntityService.configure.<anonymous>.<anonymous>' call
                  if (element.q1t().m1t() === cmpId) {
                    tmp$ret$0 = true;
                    break $l$block_0;
                  }
                }
                tmp$ret$0 = false;
              }
              if (tmp$ret$0) {
                break $l$block_1;
              }
              var tmp0_safe_receiver = this.n1v_1.g1u(cmpId);
              if (tmp0_safe_receiver == null)
                null;
              else {
                tmp0_safe_receiver.o1u(entity);
              }
            }
            bitsAtWord = bitsAtWord.j4((new Long(1, 0)).e4(bit));
          }
        }
      }
       while (0 <= inductionVariable);
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator_0 = components.b1();
    while (tmp0_iterator_0.c1()) {
      var element_0 = tmp0_iterator_0.d1();
      // Inline function 'com.github.quillraven.fleks.EntityService.configure.<anonymous>' call
      compMask.p1s(element_0.q1t().m1t());
      var holder = this.n1v_1.w1t(element_0.q1t());
      holder.k1u(entity, element_0);
    }
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator_1 = snapshot.b1w_1.b1();
    while (tmp0_iterator_1.c1()) {
      var element_1 = tmp0_iterator_1.d1();
      // Inline function 'com.github.quillraven.fleks.EntityService.configure.<anonymous>' call
      compMask.p1s(element_1.m1t());
      // Inline function 'kotlin.collections.set' call
      var this_0 = this.l1v_1.f1u_1;
      var key = element_1.m1t();
      this_0.k3(key, element_1);
    }
    // Inline function 'kotlin.collections.forEach' call
    var indexedObject = this.l1v_1.b1u_1;
    var inductionVariable_0 = 0;
    var last = indexedObject.length;
    while (inductionVariable_0 < last) {
      var element_2 = indexedObject[inductionVariable_0];
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      // Inline function 'com.github.quillraven.fleks.EntityService.configure.<anonymous>' call
      element_2.p1w(entity, compMask);
    }
  }
  q1w(entity) {
    this.m1v_1.o1u(entity);
    this.o1v_1.h1s(entity.m1u_1, new BitArray(64));
  }
  o1u(entity) {
    if (!this.m1v_1.w1s(entity)) {
      return Unit_instance;
    }
    if (this.t1v_1) {
      this.u1v_1.y1s(entity);
    } else {
      this.m1v_1.o1u(entity);
      var compMask = this.o1v_1.h1(entity.m1u_1);
      var tmp0_safe_receiver = this.w1v_1;
      if (tmp0_safe_receiver == null)
        null;
      else
        tmp0_safe_receiver(this.l1v_1, entity);
      // Inline function 'kotlin.collections.forEach' call
      var indexedObject = this.l1v_1.b1u_1;
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var element = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.github.quillraven.fleks.EntityService.minusAssign.<anonymous>' call
        element.r1w(entity);
      }
      // Inline function 'com.github.quillraven.fleks.collection.BitArray.clearAndForEachSetBit' call
      var inductionVariable_0 = compMask.m1s_1.length - 1 | 0;
      if (0 <= inductionVariable_0)
        do {
          var word = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + -1 | 0;
          var bitsAtWord = compMask.m1s_1[word];
          if (!bitsAtWord.equals(new Long(0, 0))) {
            var w = word << 6;
            while (!bitsAtWord.equals(new Long(0, 0))) {
              compMask.m1s_1[word] = new Long(0, 0);
              var bit = 63 - countLeadingZeroBits(bitsAtWord) | 0;
              // Inline function 'com.github.quillraven.fleks.EntityService.minusAssign.<anonymous>' call
              var compId = w + bit | 0;
              var tmp0_safe_receiver_0 = this.n1v_1.g1u(compId);
              if (tmp0_safe_receiver_0 == null)
                null;
              else {
                tmp0_safe_receiver_0.o1u(entity);
              }
              bitsAtWord = bitsAtWord.j4((new Long(1, 0)).e4(bit));
            }
          }
        }
         while (0 <= inductionVariable_0);
    }
  }
  s1w(clearRecycled) {
    var tmp = this.m1v_1;
    tmp.t1w(EntityService$removeAll$lambda);
    if (clearRecycled) {
      this.m1v_1.u1w();
      this.o1v_1.h3();
    }
  }
  w1s(entity) {
    return this.m1v_1.w1s(entity);
  }
  t1w(action) {
    this.m1v_1.t1w(action);
  }
  v1w() {
    this.t1v_1 = false;
    if (this.u1v_1.d1t()) {
      // Inline function 'com.github.quillraven.fleks.collection.MutableEntityBag.forEach' call
      var this_0 = this.u1v_1;
      var inductionVariable = 0;
      var last = this_0.v1s_1;
      if (inductionVariable < last)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'com.github.quillraven.fleks.EntityService.cleanupDelays.<anonymous>' call
          var it = this_0.u1s_1[i];
          this.o1u(it);
        }
         while (inductionVariable < last);
      this.u1v_1.h3();
    }
  }
}
class DefaultEntityProvider {
  constructor(world, initialEntityCapacity) {
    this.w1w_1 = world;
    this.x1w_1 = 0;
    this.y1w_1 = ArrayDeque.ll();
    var tmp = this;
    // Inline function 'com.github.quillraven.fleks.collection.bag' call
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp$ret$0 = fillArrayVal(Array(initialEntityCapacity), null);
    tmp.z1w_1 = new Bag(tmp$ret$0);
  }
  y1v() {
    return this.x1w_1 - this.y1w_1.hl_1 | 0;
  }
  a1x() {
    // Inline function 'kotlin.also' call
    var tmp;
    if (this.y1w_1.j1()) {
      var _unary__edvuaz = this.x1w_1;
      this.x1w_1 = _unary__edvuaz + 1 | 0;
      tmp = new Entity(_unary__edvuaz, _UInt___init__impl__l7qpdl(0));
    } else {
      var recycled = this.y1w_1.sl();
      if (recycled.m1u_1 >= this.x1w_1) {
        this.x1w_1 = recycled.m1u_1 + 1 | 0;
      }
      // Inline function 'kotlin.UInt.plus' call
      var this_0 = recycled.n1u_1;
      var other = _UInt___init__impl__l7qpdl(1);
      var tmp$ret$0 = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_0) + _UInt___get_data__impl__f0vqqw(other) | 0);
      tmp = recycled.a1v(VOID, tmp$ret$0);
    }
    var this_1 = tmp;
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.github.quillraven.fleks.DefaultEntityProvider.create.<anonymous>' call
    this.z1w_1.h1s(this_1.m1u_1, this_1);
    return this_1;
  }
  o1u(entity) {
    this.y1w_1.h(entity);
    this.z1w_1.l1s(entity.m1u_1);
  }
  w1s(entity) {
    var tmp0_safe_receiver = this.z1w_1.i1s(entity.m1u_1);
    var tmp = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.n1u_1;
    return equals(tmp == null ? null : new UInt(tmp), new UInt(entity.n1u_1));
  }
  u1w() {
    this.x1w_1 = 0;
    this.y1w_1.h3();
    this.z1w_1.h3();
  }
  t1w(action) {
    // Inline function 'com.github.quillraven.fleks.collection.Bag.forEach' call
    var this_0 = this.z1w_1;
    var inductionVariable = 0;
    var last = this_0.f1s_1;
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp0_safe_receiver = this_0.e1s_1[i];
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          action(this.w1w_1, tmp0_safe_receiver);
        }
      }
       while (inductionVariable < last);
  }
}
class FleksException extends RuntimeException {
  static j1x(message) {
    var $this = this.bb(message);
    captureStack($this, $this.i1x_1);
    return $this;
  }
}
class FleksNoSuchInjectableException extends FleksException {
  static f1x(name) {
    var $this = this.j1x('There is no injectable with name ' + name + " registered! Make sure to define 'injectables' before your 'systems' in the WorldConfiguration.");
    captureStack($this, $this.e1x_1);
    return $this;
  }
}
class FleksNoSuchSystemException extends FleksException {
  static o1x(system) {
    var $this = this.j1x("There is no system of type '" + system.yf() + "' in the world.");
    captureStack($this, $this.n1x_1);
    return $this;
  }
}
class FleksSystemAlreadyAddedException extends FleksException {
  static t1x(system) {
    var $this = this.j1x("System '" + system.yf() + "' is already part of the '" + getKClass(WorldConfiguration).yf() + "'.");
    captureStack($this, $this.s1x_1);
    return $this;
  }
}
class FleksFamilyException extends FleksException {
  static y1x(familyDefinition) {
    var $this = this.j1x('Family must have at least one of allOf, noneOf or anyOf. Definition: ' + familyDefinition.toString() + '}');
    captureStack($this, $this.x1x_1);
    return $this;
  }
}
class FleksSnapshotException extends FleksException {
  static d1y(reason) {
    var $this = this.j1x('Cannot load snapshot: ' + reason + '!');
    captureStack($this, $this.c1y_1);
    return $this;
  }
}
class FleksWrongSystemInterfaceException extends FleksException {
  static i1y(system, interface_0) {
    var $this = this.j1x('System ' + system.yf() + ' cannot have interface ' + interface_0.yf());
    captureStack($this, $this.h1y_1);
    return $this;
  }
}
class FleksWrongConfigurationUsageException extends FleksException {
  static j1t() {
    var $this = this.j1x("The global functions 'inject' and 'family' must be used inside a WorldConfiguration scope.The same applies for 'compareEntityBy' and 'compareEntity' unless you specify the world parameter explicitly.");
    captureStack($this, $this.i1t_1);
    return $this;
  }
}
class FleksNoSuchEntityComponentException extends FleksException {
  static u1u(entity, component) {
    var $this = this.j1x("Entity '" + entity.toString() + "' has no component of type '" + component + "'.");
    captureStack($this, $this.t1u_1);
    return $this;
  }
}
class FleksWorldModificationDuringConfigurationException extends FleksException {
  static n1y() {
    var $this = this.j1x("Entities were added during world configuration. Most likely in a constructor of a system. Create those entities in the 'onInit' method of a system instead.");
    captureStack($this, $this.m1y_1);
    return $this;
  }
}
class FleksInjectableAlreadyAddedException extends FleksException {
  static s1y(name) {
    var $this = this.j1x("Injectable with name '" + name + "' is already part of the '" + getKClass(WorldConfiguration).yf() + "'. " + "Please add a unique 'name' string as parameter to the 'add' function of the 'injectables' block.");
    captureStack($this, $this.r1y_1);
    return $this;
  }
}
class Family extends EntityComponentContext {
  static t1y(allOf, noneOf, anyOf, world, entityService) {
    allOf = allOf === VOID ? null : allOf;
    noneOf = noneOf === VOID ? null : noneOf;
    anyOf = anyOf === VOID ? null : anyOf;
    entityService = entityService === VOID ? world.a1u_1 : entityService;
    var $this = this.j1v(world.i1v_1);
    $this.d1w_1 = allOf;
    $this.e1w_1 = noneOf;
    $this.f1w_1 = anyOf;
    $this.g1w_1 = world;
    $this.h1w_1 = entityService;
    $this.i1w_1 = null;
    $this.j1w_1 = null;
    var tmp = $this;
    // Inline function 'com.github.quillraven.fleks.collection.bag' call
    // Inline function 'kotlin.arrayOfNulls' call
    var size = $this.g1w_1.g1s();
    var tmp$ret$0 = fillArrayVal(Array(size), null);
    tmp.k1w_1 = new Bag(tmp$ret$0);
    $this.l1w_1 = 0;
    $this.m1w_1 = false;
    $this.n1w_1 = new MutableEntityBag();
    $this.o1w_1 = false;
    return $this;
  }
  u1y() {
    if (this.o1w_1 && !this.m1w_1) {
      this.o1w_1 = false;
      this.n1w_1.z1s(this.k1w_1.f1s_1);
      // Inline function 'com.github.quillraven.fleks.collection.Bag.forEach' call
      var this_0 = this.k1w_1;
      var inductionVariable = 0;
      var last = this_0.f1s_1;
      if (inductionVariable < last)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var tmp0_safe_receiver = this_0.e1s_1[i];
          if (tmp0_safe_receiver == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.contracts.contract' call
            this.n1w_1.y1s(tmp0_safe_receiver);
          }
        }
         while (inductionVariable < last);
    }
    return this.n1w_1;
  }
  x1v() {
    return this.l1w_1;
  }
  v1y(compMask) {
    return (this.d1w_1 == null || compMask.s1s(this.d1w_1)) && (this.e1w_1 == null || !compMask.r1s(this.e1w_1)) && (this.f1w_1 == null || compMask.r1s(this.f1w_1));
  }
  nl() {
    return this.u1y().nl();
  }
  a1t(comparator) {
    return this.u1y().a1t(comparator);
  }
  w1y(entity, compMask) {
    if (this.v1y(compMask)) {
      this.o1w_1 = true;
      if (this.k1w_1.j1s(entity.m1u_1)) {
        this.l1w_1 = this.l1w_1 + 1 | 0;
      }
      this.k1w_1.h1s(entity.m1u_1, entity);
      var tmp0_safe_receiver = this.i1w_1;
      if (tmp0_safe_receiver == null)
        null;
      else
        tmp0_safe_receiver(this.g1w_1, entity);
    }
  }
  p1w(entity, compMask) {
    var entityInFamily = this.v1y(compMask);
    var currentEntity = this.k1w_1.i1s(entity.m1u_1);
    if (entityInFamily && currentEntity == null) {
      this.o1w_1 = true;
      this.l1w_1 = this.l1w_1 + 1 | 0;
      this.k1w_1.h1s(entity.m1u_1, entity);
      var tmp0_safe_receiver = this.i1w_1;
      if (tmp0_safe_receiver == null)
        null;
      else
        tmp0_safe_receiver(this.g1w_1, entity);
    } else if (!entityInFamily && !(currentEntity == null)) {
      this.o1w_1 = true;
      this.l1w_1 = this.l1w_1 - 1 | 0;
      this.k1w_1.l1s(entity.m1u_1);
      var tmp1_safe_receiver = this.j1w_1;
      if (tmp1_safe_receiver == null)
        null;
      else
        tmp1_safe_receiver(this.g1w_1, entity);
    }
  }
  r1w(entity) {
    if (this.k1w_1.k1s(entity.m1u_1)) {
      this.o1w_1 = true;
      this.k1w_1.l1s(entity.m1u_1);
      this.l1w_1 = this.l1w_1 - 1 | 0;
      var tmp0_safe_receiver = this.j1w_1;
      if (tmp0_safe_receiver == null)
        null;
      else
        tmp0_safe_receiver(this.g1w_1, entity);
    }
  }
  toString() {
    return 'Family(allOf=' + toString_0(this.d1w_1) + ', noneOf=' + toString_0(this.e1w_1) + ', anyOf=' + toString_0(this.f1w_1) + ', numEntities=' + this.x1v() + ')';
  }
  hashCode() {
    var result = this.d1w_1 == null ? 0 : this.d1w_1.hashCode();
    result = imul(result, 31) + (this.e1w_1 == null ? 0 : this.e1w_1.hashCode()) | 0;
    result = imul(result, 31) + (this.f1w_1 == null ? 0 : this.f1w_1.hashCode()) | 0;
    result = imul(result, 31) + hashCode(this.g1w_1) | 0;
    result = imul(result, 31) + hashCode(this.h1w_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Family))
      return false;
    var tmp0_other_with_cast = other instanceof Family ? other : THROW_CCE();
    if (!equals(this.d1w_1, tmp0_other_with_cast.d1w_1))
      return false;
    if (!equals(this.e1w_1, tmp0_other_with_cast.e1w_1))
      return false;
    if (!equals(this.f1w_1, tmp0_other_with_cast.f1w_1))
      return false;
    if (!equals(this.g1w_1, tmp0_other_with_cast.g1w_1))
      return false;
    if (!equals(this.h1w_1, tmp0_other_with_cast.h1w_1))
      return false;
    return true;
  }
}
class FamilyDefinition {
  constructor(allOf, noneOf, anyOf) {
    allOf = allOf === VOID ? null : allOf;
    noneOf = noneOf === VOID ? null : noneOf;
    anyOf = anyOf === VOID ? null : anyOf;
    this.x1y_1 = allOf;
    this.y1y_1 = noneOf;
    this.z1y_1 = anyOf;
  }
  a1z(types) {
    var tmp = this;
    // Inline function 'kotlin.also' call
    var this_0 = new BitArray(types.length);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.github.quillraven.fleks.FamilyDefinition.all.<anonymous>' call
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable = 0;
    var last = types.length;
    while (inductionVariable < last) {
      var element = types[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.github.quillraven.fleks.FamilyDefinition.all.<anonymous>.<anonymous>' call
      this_0.p1s(element.m1t());
    }
    tmp.x1y_1 = this_0;
    return this;
  }
  b1z(types) {
    var tmp = this;
    // Inline function 'kotlin.also' call
    var this_0 = new BitArray(types.length);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.github.quillraven.fleks.FamilyDefinition.none.<anonymous>' call
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable = 0;
    var last = types.length;
    while (inductionVariable < last) {
      var element = types[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.github.quillraven.fleks.FamilyDefinition.none.<anonymous>.<anonymous>' call
      this_0.p1s(element.m1t());
    }
    tmp.y1y_1 = this_0;
    return this;
  }
  c1z(types) {
    var tmp = this;
    // Inline function 'kotlin.also' call
    var this_0 = new BitArray(types.length);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.github.quillraven.fleks.FamilyDefinition.any.<anonymous>' call
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable = 0;
    var last = types.length;
    while (inductionVariable < last) {
      var element = types[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.github.quillraven.fleks.FamilyDefinition.any.<anonymous>.<anonymous>' call
      this_0.p1s(element.m1t());
    }
    tmp.z1y_1 = this_0;
    return this;
  }
  d1z() {
    return isNullOrEmpty(this.x1y_1) && isNullOrEmpty(this.y1y_1) && isNullOrEmpty(this.z1y_1);
  }
  e1z() {
    return this.x1y_1;
  }
  f1z() {
    return this.y1y_1;
  }
  g1z() {
    return this.z1y_1;
  }
  toString() {
    return 'FamilyDefinition(allOf=' + toString_0(this.x1y_1) + ', noneOf=' + toString_0(this.y1y_1) + ', anyOf=' + toString_0(this.z1y_1) + ')';
  }
  hashCode() {
    var result = this.x1y_1 == null ? 0 : this.x1y_1.hashCode();
    result = imul(result, 31) + (this.y1y_1 == null ? 0 : this.y1y_1.hashCode()) | 0;
    result = imul(result, 31) + (this.z1y_1 == null ? 0 : this.z1y_1.hashCode()) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof FamilyDefinition))
      return false;
    var tmp0_other_with_cast = other instanceof FamilyDefinition ? other : THROW_CCE();
    if (!equals(this.x1y_1, tmp0_other_with_cast.x1y_1))
      return false;
    if (!equals(this.y1y_1, tmp0_other_with_cast.y1y_1))
      return false;
    if (!equals(this.z1y_1, tmp0_other_with_cast.z1y_1))
      return false;
    return true;
  }
}
class sam$kotlin_Comparator$0_0 {
  constructor(function_0) {
    this.h1z_1 = function_0;
  }
  vj(a, b) {
    return this.h1z_1(a, b);
  }
  compare(a, b) {
    return this.vj(a, b);
  }
  o4() {
    return this.h1z_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Comparator) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.o4(), other.o4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.o4());
  }
}
class Companion_2 {
  constructor() {
    Companion_instance_2 = this;
    var tmp = this;
    var tmp_0 = IteratingSystem$Companion$EMPTY_COMPARATOR$lambda;
    tmp.i1z_1 = new sam$kotlin_Comparator$0_0(tmp_0);
  }
}
class IntervalSystem extends EntityComponentContext {
  static y1z(interval, enabled, world) {
    interval = interval === VOID ? EachFrame_instance : interval;
    enabled = enabled === VOID ? true : enabled;
    var tmp;
    if (world === VOID) {
      var tmp0_elvis_lhs = Companion_instance_3.e1t_1;
      var tmp_0;
      if (tmp0_elvis_lhs == null) {
        throw FleksWrongConfigurationUsageException.j1t();
      } else {
        tmp_0 = tmp0_elvis_lhs;
      }
      tmp = tmp_0;
    } else {
      tmp = world;
    }
    world = tmp;
    var $this = this.j1v(world.i1v_1);
    $this.u1z_1 = interval;
    $this.v1z_1 = world;
    $this.w1z_1 = enabled;
    $this.x1z_1 = 0.0;
    return $this;
  }
  f20(value) {
    if (value === this.w1z_1) {
      return Unit_instance;
    }
    this.w1z_1 = value;
    if (value) {
      this.i20();
    } else {
      this.j20();
    }
  }
  g20() {
    var tmp;
    var tmp_0 = this.u1z_1;
    if (tmp_0 instanceof Fixed) {
      tmp = this.u1z_1.l20_1;
    } else {
      tmp = this.v1z_1.z1t_1;
    }
    return tmp;
  }
  h20() {
    return Unit_instance;
  }
  i20() {
    return Unit_instance;
  }
  j20() {
    return Unit_instance;
  }
  k20() {
    var tmp0_subject = this.u1z_1;
    if (tmp0_subject instanceof EachFrame) {
      this.b20();
    } else {
      if (tmp0_subject instanceof Fixed) {
        this.x1z_1 = this.x1z_1 + this.v1z_1.z1t_1;
        var stepRate = this.u1z_1.l20_1;
        while (this.x1z_1 >= stepRate) {
          this.b20();
          this.x1z_1 = this.x1z_1 - stepRate;
        }
        this.d20(this.x1z_1 / stepRate);
      } else {
        noWhenBranchMatchedException();
      }
    }
  }
  d20(alpha) {
    return Unit_instance;
  }
}
class IteratingSystem extends IntervalSystem {
  static s1z(family, comparator, sortingType, interval, enabled, world) {
    Companion_getInstance_2();
    comparator = comparator === VOID ? Companion_getInstance_2().i1z_1 : comparator;
    sortingType = sortingType === VOID ? Automatic_instance : sortingType;
    interval = interval === VOID ? EachFrame_instance : interval;
    enabled = enabled === VOID ? true : enabled;
    var $this = this.y1z(interval, enabled, world);
    $this.o1z_1 = family;
    $this.p1z_1 = comparator;
    $this.q1z_1 = sortingType;
    $this.r1z_1 = (equals($this.q1z_1, Automatic_instance) && !equals($this.p1z_1, Companion_getInstance_2().i1z_1));
    return $this;
  }
  static z1z(family, comparator, sortingType, interval, enabled) {
    Companion_getInstance_2();
    comparator = comparator === VOID ? Companion_getInstance_2().i1z_1 : comparator;
    sortingType = sortingType === VOID ? Automatic_instance : sortingType;
    interval = interval === VOID ? EachFrame_instance : interval;
    enabled = enabled === VOID ? true : enabled;
    var tmp0_elvis_lhs = Companion_instance_3.e1t_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw FleksWrongConfigurationUsageException.j1t();
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return this.s1z(family, comparator, sortingType, interval, enabled, tmp);
  }
  a20() {
    if (this.r1z_1) {
      this.r1z_1 = equals(this.q1z_1, Automatic_instance);
      this.o1z_1.a1t(this.p1z_1);
    }
  }
  b20() {
    this.a20();
    // Inline function 'com.github.quillraven.fleks.Family.forEach' call
    var this_0 = this.o1z_1;
    var entitiesForIteration = this_0.u1y();
    if (!this_0.h1w_1.t1v_1) {
      this_0.h1w_1.t1v_1 = true;
      this_0.m1w_1 = true;
      // Inline function 'com.github.quillraven.fleks.collection.MutableEntityBag.forEach' call
      var inductionVariable = 0;
      var last = entitiesForIteration.v1s_1;
      if (inductionVariable < last)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'com.github.quillraven.fleks.Family.forEach.<anonymous>' call
          // Inline function 'com.github.quillraven.fleks.IteratingSystem.onTick.<anonymous>' call
          var it = entitiesForIteration.u1s_1[i];
          this.c20(it);
        }
         while (inductionVariable < last);
      this_0.m1w_1 = false;
      this_0.h1w_1.v1w();
    } else {
      var origIterating = this_0.m1w_1;
      this_0.m1w_1 = true;
      // Inline function 'com.github.quillraven.fleks.collection.MutableEntityBag.forEach' call
      var inductionVariable_0 = 0;
      var last_0 = entitiesForIteration.v1s_1;
      if (inductionVariable_0 < last_0)
        do {
          var i_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          // Inline function 'com.github.quillraven.fleks.Family.forEach.<anonymous>' call
          // Inline function 'com.github.quillraven.fleks.IteratingSystem.onTick.<anonymous>' call
          var it_0 = entitiesForIteration.u1s_1[i_0];
          this.c20(it_0);
        }
         while (inductionVariable_0 < last_0);
      this_0.m1w_1 = origIterating;
    }
  }
  d20(alpha) {
    // Inline function 'com.github.quillraven.fleks.Family.forEach' call
    var this_0 = this.o1z_1;
    var entitiesForIteration = this_0.u1y();
    if (!this_0.h1w_1.t1v_1) {
      this_0.h1w_1.t1v_1 = true;
      this_0.m1w_1 = true;
      // Inline function 'com.github.quillraven.fleks.collection.MutableEntityBag.forEach' call
      var inductionVariable = 0;
      var last = entitiesForIteration.v1s_1;
      if (inductionVariable < last)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'com.github.quillraven.fleks.Family.forEach.<anonymous>' call
          // Inline function 'com.github.quillraven.fleks.IteratingSystem.onAlpha.<anonymous>' call
          var it = entitiesForIteration.u1s_1[i];
          this.e20(it, alpha);
        }
         while (inductionVariable < last);
      this_0.m1w_1 = false;
      this_0.h1w_1.v1w();
    } else {
      var origIterating = this_0.m1w_1;
      this_0.m1w_1 = true;
      // Inline function 'com.github.quillraven.fleks.collection.MutableEntityBag.forEach' call
      var inductionVariable_0 = 0;
      var last_0 = entitiesForIteration.v1s_1;
      if (inductionVariable_0 < last_0)
        do {
          var i_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          // Inline function 'com.github.quillraven.fleks.Family.forEach.<anonymous>' call
          // Inline function 'com.github.quillraven.fleks.IteratingSystem.onAlpha.<anonymous>' call
          var it_0 = entitiesForIteration.u1s_1[i_0];
          this.e20(it_0, alpha);
        }
         while (inductionVariable_0 < last_0);
      this_0.m1w_1 = origIterating;
    }
  }
  e20(entity, alpha) {
    return Unit_instance;
  }
}
class EachFrame {
  toString() {
    return 'EachFrame';
  }
  hashCode() {
    return -1601706080;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof EachFrame))
      return false;
    other instanceof EachFrame || THROW_CCE();
    return true;
  }
}
class Fixed {
  constructor(step) {
    this.l20_1 = step;
  }
  toString() {
    return 'Fixed(step=' + this.l20_1 + ')';
  }
  hashCode() {
    return getNumberHashCode(this.l20_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Fixed))
      return false;
    var tmp0_other_with_cast = other instanceof Fixed ? other : THROW_CCE();
    if (!equals(this.l20_1, tmp0_other_with_cast.l20_1))
      return false;
    return true;
  }
}
class FamilyOnAdd {}
class FamilyOnRemove {}
class Automatic {
  toString() {
    return 'Automatic';
  }
  hashCode() {
    return -26760737;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Automatic))
      return false;
    other instanceof Automatic || THROW_CCE();
    return true;
  }
}
class Companion_3 {
  constructor() {
    this.e1t_1 = null;
  }
  p20(cfg) {
    var tmp0_safe_receiver = this.e1t_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.p20(cfg);
    var tmp;
    if (tmp1_elvis_lhs == null) {
      throw FleksWrongConfigurationUsageException.j1t();
    } else {
      tmp = tmp1_elvis_lhs;
    }
    return tmp;
  }
}
class World extends EntityComponentContext {
  static r20(entityCapacity) {
    var $this = this.j1v(new ComponentService());
    var tmp = $this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp.y1t_1 = LinkedHashMap.wc();
    $this.z1t_1 = 0.0;
    $this.a1u_1 = new EntityService($this, entityCapacity);
    var tmp_0 = $this;
    // Inline function 'kotlin.emptyArray' call
    tmp_0.b1u_1 = [];
    var tmp_1 = $this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp_1.c1u_1 = ArrayList.z();
    var tmp_2 = $this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp_2.d1u_1 = LinkedHashMap.wc();
    var tmp_3 = $this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp_3.e1u_1 = LinkedHashMap.wc();
    var tmp_4 = $this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp_4.f1u_1 = LinkedHashMap.wc();
    $this.i1v_1.t1t_1 = $this;
    return $this;
  }
  x1v() {
    return this.a1u_1.x1v();
  }
  g1s() {
    return this.a1u_1.g1s();
  }
  o20() {
    return this.c1u_1;
  }
  o1u(entity) {
    this.a1u_1.o1u(entity);
  }
  s1w(clearRecycled) {
    this.a1u_1.s1w(clearRecycled);
  }
  p20(cfg) {
    // Inline function 'kotlin.apply' call
    var this_0 = new FamilyDefinition();
    // Inline function 'kotlin.contracts.contract' call
    cfg(this_0);
    return this.s20(this_0);
  }
  s20(definition) {
    if (definition.d1z()) {
      throw FleksFamilyException.y1x(definition);
    }
    var defAll = definition.e1z();
    var defNone = definition.f1z();
    var defAny = definition.g1z();
    // Inline function 'kotlin.collections.find' call
    var this_0 = this.b1u_1;
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var inductionVariable = 0;
      var last = this_0.length;
      while (inductionVariable < last) {
        var element = this_0[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.github.quillraven.fleks.World.family.<anonymous>' call
        if (equals(element.d1w_1, defAll) && equals(element.e1w_1, defNone) && equals(element.f1w_1, defAny)) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    var family = {_v: tmp$ret$1};
    if (family._v == null) {
      family._v = Family.t1y(defAll, defNone, defAny, this);
      var tmp = this;
      // Inline function 'kotlin.collections.plus' call
      var this_1 = this.b1u_1;
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$6 = [family._v];
      tmp.b1u_1 = this_1.concat(tmp$ret$6);
      this.a1u_1.t1w(World$family$lambda(family));
    }
    return family._v;
  }
  t20() {
    // Inline function 'kotlin.collections.mutableMapOf' call
    var result = LinkedHashMap.wc();
    this.a1u_1.t1w(World$snapshot$lambda(result));
    return result;
  }
  q20(entity) {
    // Inline function 'kotlin.collections.mutableListOf' call
    var comps = ArrayList.z();
    // Inline function 'kotlin.collections.mutableListOf' call
    var tags = ArrayList.z();
    if (this.a1u_1.w1s(entity)) {
      // Inline function 'com.github.quillraven.fleks.collection.BitArray.forEachSetBit' call
      var this_0 = this.a1u_1.o1v_1.h1(entity.m1u_1);
      var inductionVariable = this_0.m1s_1.length - 1 | 0;
      if (0 <= inductionVariable)
        do {
          var word = inductionVariable;
          inductionVariable = inductionVariable + -1 | 0;
          var bitsAtWord = this_0.m1s_1[word];
          if (!bitsAtWord.equals(new Long(0, 0))) {
            var w = word << 6;
            while (!bitsAtWord.equals(new Long(0, 0))) {
              var bit = 63 - countLeadingZeroBits(bitsAtWord) | 0;
              // Inline function 'com.github.quillraven.fleks.World.snapshotOf.<anonymous>' call
              var cmpId = w + bit | 0;
              var holder = this.i1v_1.g1u(cmpId);
              if (holder == null) {
                // Inline function 'kotlin.collections.plusAssign' call
                var tmp0_elvis_lhs = this.f1u_1.e3(cmpId);
                var tmp;
                if (tmp0_elvis_lhs == null) {
                  throw FleksSnapshotException.d1y('Tag with id ' + cmpId + ' was never assigned');
                } else {
                  tmp = tmp0_elvis_lhs;
                }
                var element = tmp;
                tags.h(element);
              } else {
                // Inline function 'kotlin.collections.plusAssign' call
                var element_0 = holder.p1u(entity);
                comps.h(element_0);
              }
              bitsAtWord = bitsAtWord.j4((new Long(1, 0)).e4(bit));
            }
          }
        }
         while (0 <= inductionVariable);
    }
    var tmp_0 = isInterface(comps, KtList) ? comps : THROW_CCE();
    return new Snapshot(tmp_0, isInterface(tags, KtList) ? tags : THROW_CCE());
  }
  u20(snapshot) {
    if (this.a1u_1.t1v_1) {
      throw FleksSnapshotException.d1y('Snapshots cannot be loaded while a family iteration is in process');
    }
    this.s1w(true);
    if (snapshot.j1()) {
      return Unit_instance;
    }
    // Inline function 'kotlin.collections.associateBy' call
    var this_0 = snapshot.f3();
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap.xc(capacity);
    var tmp0_iterator = this_0.b1();
    while (tmp0_iterator.c1()) {
      var element = tmp0_iterator.d1();
      // Inline function 'com.github.quillraven.fleks.World.loadSnapshot.<anonymous>' call
      var tmp$ret$0 = element.m1u_1;
      destination.k3(tmp$ret$0, element);
    }
    var versionLookup = destination;
    // Inline function 'kotlin.with' call
    // Inline function 'kotlin.contracts.contract' call
    var $this$with = this.a1u_1;
    // Inline function 'kotlin.collections.maxOf' call
    var iterator = snapshot.f3().b1();
    if (!iterator.c1())
      throw NoSuchElementException.x6();
    // Inline function 'com.github.quillraven.fleks.World.loadSnapshot.<anonymous>.<anonymous>' call
    var maxValue = iterator.d1().m1u_1;
    while (iterator.c1()) {
      // Inline function 'com.github.quillraven.fleks.World.loadSnapshot.<anonymous>.<anonymous>' call
      var v = iterator.d1().m1u_1;
      if (compareTo(maxValue, v) < 0) {
        maxValue = v;
      }
    }
    var maxId = maxValue;
    // Inline function 'kotlin.repeat' call
    var times = maxId + 1 | 0;
    // Inline function 'kotlin.contracts.contract' call
    var inductionVariable = 0;
    if (inductionVariable < times)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.github.quillraven.fleks.World.loadSnapshot.<anonymous>.<anonymous>' call
        // Inline function 'kotlin.UInt.minus' call
        var tmp0_safe_receiver = versionLookup.e3(index);
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.n1u_1;
        var tmp;
        var tmp_0 = tmp1_elvis_lhs;
        if ((tmp_0 == null ? null : new UInt(tmp_0)) == null) {
          tmp = _UInt___init__impl__l7qpdl(0);
        } else {
          tmp = tmp1_elvis_lhs;
        }
        var this_1 = tmp;
        var other = _UInt___init__impl__l7qpdl(1);
        var tmp$ret$6 = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_1) - _UInt___get_data__impl__f0vqqw(other) | 0);
        var entity = new Entity(index, tmp$ret$6);
        $this$with.q1w(entity);
        // Inline function 'kotlin.collections.get' call
        var key = versionLookup.e3(index);
        var entitySnapshot = (isInterface(snapshot, KtMap) ? snapshot : THROW_CCE()).e3(key);
        if (!(entitySnapshot == null)) {
          // Inline function 'com.github.quillraven.fleks.EntityService.create' call
          // Inline function 'com.github.quillraven.fleks.EntityService.postCreate' call
          var entity_0 = $this$with.m1v_1.a1x();
          if (entity_0.m1u_1 >= $this$with.o1v_1.f1s_1) {
            $this$with.o1v_1.h1s(entity_0.m1u_1, new BitArray(64));
          }
          var prevCreateId = $this$with.q1v_1;
          $this$with.q1v_1 = entity_0.m1u_1;
          // Inline function 'com.github.quillraven.fleks.World.loadSnapshot.<anonymous>.<anonymous>.<anonymous>' call
          $this$with.p1v_1;
          $this$with.q1v_1 = prevCreateId;
          var compMask = $this$with.o1v_1.h1(entity_0.m1u_1);
          // Inline function 'kotlin.collections.forEach' call
          var indexedObject = $this$with.l1v_1.b1u_1;
          var inductionVariable_0 = 0;
          var last = indexedObject.length;
          while (inductionVariable_0 < last) {
            var element_0 = indexedObject[inductionVariable_0];
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            // Inline function 'com.github.quillraven.fleks.EntityService.postCreate.<anonymous>' call
            element_0.w1y(entity_0, compMask);
          }
          var tmp0_safe_receiver_0 = $this$with.v1v_1;
          if (tmp0_safe_receiver_0 == null)
            null;
          else
            tmp0_safe_receiver_0($this$with.l1v_1, entity_0);
          $this$with.z1v(entity_0, entitySnapshot);
        }
      }
       while (inductionVariable < times);
  }
  v20(deltaTime) {
    this.z1t_1 = deltaTime;
    var inductionVariable = 0;
    var last = this.o20().g1() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var system = this.o20().h1(i);
        if (system.w1z_1) {
          system.k20();
        }
      }
       while (inductionVariable <= last);
  }
  w20() {
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = this.o20().b1();
    while (tmp0_iterator.c1()) {
      var element = tmp0_iterator.d1();
      // Inline function 'com.github.quillraven.fleks.World.initAggregatedFamilyHooks.<anonymous>' call
      if (!(element instanceof IteratingSystem)) {
        if (isInterface(element, FamilyOnAdd)) {
          throw FleksWrongSystemInterfaceException.i1y(getKClassFromExpression(element), getKClass(FamilyOnAdd));
        }
        if (isInterface(element, FamilyOnRemove)) {
          throw FleksWrongSystemInterfaceException.i1y(getKClassFromExpression(element), getKClass(FamilyOnRemove));
        }
      }
    }
    // Inline function 'kotlin.collections.forEach' call
    var indexedObject = this.b1u_1;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element_0 = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.github.quillraven.fleks.World.initAggregatedFamilyHooks.<anonymous>' call
      // Inline function 'kotlin.collections.set' call
      var this_0 = this.d1u_1;
      var value = element_0.i1w_1;
      this_0.k3(element_0, value);
      // Inline function 'kotlin.collections.set' call
      var this_1 = this.e1u_1;
      var value_0 = element_0.j1w_1;
      this_1.k3(element_0, value_0);
    }
    // Inline function 'kotlin.collections.forEach' call
    var indexedObject_0 = this.b1u_1;
    var inductionVariable_0 = 0;
    var last_0 = indexedObject_0.length;
    while (inductionVariable_0 < last_0) {
      var element_1 = indexedObject_0[inductionVariable_0];
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      // Inline function 'com.github.quillraven.fleks.World.initAggregatedFamilyHooks.<anonymous>' call
      updateAggregatedFamilyHooks(this, element_1);
    }
  }
}
class Companion_4 {
  constructor() {
    Companion_instance_4 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    var tmp_0 = getKClass(Component);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$2 = [];
    var tmp_1 = new ArrayListSerializer(PolymorphicSerializer.qv(tmp_0, tmp$ret$2));
    var tmp_2 = getKClass(UniqueId);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$5 = [];
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.x20_1 = [tmp_1, new ArrayListSerializer(PolymorphicSerializer.qv(tmp_2, tmp$ret$5))];
  }
}
class $serializer_0 {
  constructor() {
    $serializer_instance_0 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.github.quillraven.fleks.Snapshot', this, 2);
    tmp0_serialDesc.m16('components', false);
    tmp0_serialDesc.m16('tags', false);
    this.y20_1 = tmp0_serialDesc;
  }
  z20(encoder, value) {
    var tmp0_desc = this.y20_1;
    var tmp1_output = encoder.xy(tmp0_desc);
    var tmp2_cached = Companion_getInstance_4().x20_1;
    tmp1_output.p10(tmp0_desc, 0, tmp2_cached[0], value.a1w_1);
    tmp1_output.p10(tmp0_desc, 1, tmp2_cached[1], value.b1w_1);
    tmp1_output.yy(tmp0_desc);
  }
  zu(encoder, value) {
    return this.z20(encoder, value instanceof Snapshot ? value : THROW_CCE());
  }
  av(decoder) {
    var tmp0_desc = this.y20_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.xy(tmp0_desc);
    var tmp7_cached = Companion_getInstance_4().x20_1;
    if (tmp6_input.nz()) {
      tmp4_local0 = tmp6_input.jz(tmp0_desc, 0, tmp7_cached[0], tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.jz(tmp0_desc, 1, tmp7_cached[1], tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.oz(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.jz(tmp0_desc, 0, tmp7_cached[0], tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.jz(tmp0_desc, 1, tmp7_cached[1], tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException.iw(tmp2_index);
        }
      }
    tmp6_input.yy(tmp0_desc);
    return Snapshot.a21(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  }
  yu() {
    return this.y20_1;
  }
  d17() {
    var tmp0_cached = Companion_getInstance_4().x20_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp0_cached[0], tmp0_cached[1]];
  }
}
class Snapshot {
  constructor(components, tags) {
    Companion_getInstance_4();
    this.a1w_1 = components;
    this.b1w_1 = tags;
  }
  toString() {
    return 'Snapshot(components=' + toString(this.a1w_1) + ', tags=' + toString(this.b1w_1) + ')';
  }
  hashCode() {
    var result = hashCode(this.a1w_1);
    result = imul(result, 31) + hashCode(this.b1w_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Snapshot))
      return false;
    var tmp0_other_with_cast = other instanceof Snapshot ? other : THROW_CCE();
    if (!equals(this.a1w_1, tmp0_other_with_cast.a1w_1))
      return false;
    if (!equals(this.b1w_1, tmp0_other_with_cast.b1w_1))
      return false;
    return true;
  }
  static a21(seen0, components, tags, serializationConstructorMarker) {
    Companion_getInstance_4();
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_0().y20_1);
    }
    var $this = createThis(this);
    $this.a1w_1 = components;
    $this.b1w_1 = tags;
    return $this;
  }
}
class WorldConfiguration {
  constructor(world) {
    this.b21_1 = world;
    this.c21_1 = null;
    this.d21_1 = null;
    this.e21_1 = null;
  }
  g21(cfg) {
    this.c21_1 = cfg;
  }
  h21(cfg) {
    this.d21_1 = cfg;
  }
  i21(cfg) {
    this.e21_1 = cfg;
  }
  f21() {
    var tmp0_safe_receiver = this.c21_1;
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver(new InjectableConfiguration(this.b21_1));
    var tmp1_safe_receiver = this.d21_1;
    if (tmp1_safe_receiver == null)
      null;
    else
      tmp1_safe_receiver(new FamilyConfiguration(this.b21_1));
    // Inline function 'kotlin.also' call
    var this_0 = new SystemConfiguration(this.b21_1.c1u_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.github.quillraven.fleks.WorldConfiguration.configure.<anonymous>' call
    var tmp0_safe_receiver_0 = this.e21_1;
    if (tmp0_safe_receiver_0 == null)
      null;
    else
      tmp0_safe_receiver_0(this_0);
    if (this.b21_1.x1v() > 0) {
      throw FleksWorldModificationDuringConfigurationException.n1y();
    }
    this.b21_1.w20();
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = this.b21_1.o20().b1();
    while (tmp0_iterator.c1()) {
      var element = tmp0_iterator.d1();
      // Inline function 'com.github.quillraven.fleks.WorldConfiguration.configure.<anonymous>' call
      element.h20();
    }
  }
}
class InjectableConfiguration {
  constructor(world) {
    this.j21_1 = world;
  }
  k21(name, dependency) {
    // Inline function 'kotlin.collections.contains' call
    // Inline function 'kotlin.collections.containsKey' call
    var this_0 = this.j21_1.y1t_1;
    if ((isInterface(this_0, KtMap) ? this_0 : THROW_CCE()).c3(name)) {
      throw FleksInjectableAlreadyAddedException.s1y(name);
    }
    // Inline function 'kotlin.collections.set' call
    var this_1 = this.j21_1.y1t_1;
    var value = new Injectable(dependency);
    this_1.k3(name, value);
  }
}
class FamilyConfiguration {
  constructor(world) {
    this.l21_1 = world;
  }
}
class SystemConfiguration {
  constructor(systems) {
    this.m21_1 = systems;
  }
  n21(system) {
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.any' call
      var this_0 = this.m21_1;
      var tmp;
      if (isInterface(this_0, Collection)) {
        tmp = this_0.j1();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = false;
        break $l$block_0;
      }
      var tmp0_iterator = this_0.b1();
      while (tmp0_iterator.c1()) {
        var element = tmp0_iterator.d1();
        // Inline function 'com.github.quillraven.fleks.SystemConfiguration.add.<anonymous>' call
        if (getKClassFromExpression(element).equals(getKClassFromExpression(system))) {
          tmp$ret$0 = true;
          break $l$block_0;
        }
      }
      tmp$ret$0 = false;
    }
    if (tmp$ret$0) {
      throw FleksSystemAlreadyAddedException.t1x(getKClassFromExpression(system));
    }
    // Inline function 'kotlin.collections.plusAssign' call
    this.m21_1.h(system);
  }
}
class Injectable {
  constructor(injObj, used) {
    used = used === VOID ? false : used;
    this.o21_1 = injObj;
    this.p21_1 = used;
  }
  toString() {
    return 'Injectable(injObj=' + toString(this.o21_1) + ', used=' + this.p21_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.o21_1);
    result = imul(result, 31) + getBooleanHashCode(this.p21_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Injectable))
      return false;
    var tmp0_other_with_cast = other instanceof Injectable ? other : THROW_CCE();
    if (!equals(this.o21_1, tmp0_other_with_cast.o21_1))
      return false;
    if (!(this.p21_1 === tmp0_other_with_cast.p21_1))
      return false;
    return true;
  }
}
//endregion
function isNullOrEmpty(_this__u8e3s4) {
  return _this__u8e3s4 == null || _this__u8e3s4.o1s();
}
function MutableEntityBag$containsAll$lambda(this$0) {
  return function (it) {
    return this$0.w1s(it);
  };
}
function compareEntity(world, compareFun) {
  var tmp;
  if (world === VOID) {
    var tmp0_elvis_lhs = Companion_instance_3.e1t_1;
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      throw FleksWrongConfigurationUsageException.j1t();
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    tmp = tmp_0;
  } else {
    tmp = world;
  }
  world = tmp;
  var tmp_1 = compareEntity$lambda(compareFun, world);
  return new sam$kotlin_Comparator$0(tmp_1);
}
function quickSort(_this__u8e3s4, fromIdx, toIdx, comparator) {
  var len = toIdx - fromIdx | 0;
  if (len < 7) {
    selectionSort(_this__u8e3s4, fromIdx, toIdx, comparator);
    return Unit_instance;
  }
  var m = fromIdx + (len / 2 | 0) | 0;
  if (len > 7) {
    var l = fromIdx;
    var n = toIdx - 1 | 0;
    if (len > 50) {
      var s = len / 8 | 0;
      l = med3(_this__u8e3s4, l, l + s | 0, l + imul(2, s) | 0, comparator);
      m = med3(_this__u8e3s4, m - s | 0, m, m + s | 0, comparator);
      n = med3(_this__u8e3s4, n - imul(2, s) | 0, n - s | 0, n, comparator);
    }
    m = med3(_this__u8e3s4, l, m, n, comparator);
  }
  var v = _this__u8e3s4[m];
  var a = fromIdx;
  var b = a;
  var c = toIdx - 1 | 0;
  var d = c;
  $l$loop_1: while (true) {
    var comparison = 0;
    $l$loop: while (true) {
      var tmp;
      if (b <= c) {
        // Inline function 'kotlin.also' call
        var this_0 = comparator.compare(_this__u8e3s4[b], v);
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'com.github.quillraven.fleks.collection.quickSort.<anonymous>' call
        comparison = this_0;
        tmp = this_0 <= 0;
      } else {
        tmp = false;
      }
      if (!tmp) {
        break $l$loop;
      }
      if (comparison === 0) {
        var _unary__edvuaz = a;
        a = _unary__edvuaz + 1 | 0;
        swap(_this__u8e3s4, _unary__edvuaz, b);
      }
      b = b + 1 | 0;
    }
    $l$loop_0: while (true) {
      var tmp_0;
      if (c >= b) {
        // Inline function 'kotlin.also' call
        var this_1 = comparator.compare(_this__u8e3s4[c], v);
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'com.github.quillraven.fleks.collection.quickSort.<anonymous>' call
        comparison = this_1;
        tmp_0 = this_1 >= 0;
      } else {
        tmp_0 = false;
      }
      if (!tmp_0) {
        break $l$loop_0;
      }
      if (comparison === 0) {
        var tmp_1 = c;
        var _unary__edvuaz_0 = d;
        d = _unary__edvuaz_0 - 1 | 0;
        swap(_this__u8e3s4, tmp_1, _unary__edvuaz_0);
      }
      c = c - 1 | 0;
    }
    if (b > c) {
      break $l$loop_1;
    }
    var _unary__edvuaz_1 = b;
    b = _unary__edvuaz_1 + 1 | 0;
    var _unary__edvuaz_2 = c;
    c = _unary__edvuaz_2 - 1 | 0;
    swap(_this__u8e3s4, _unary__edvuaz_1, _unary__edvuaz_2);
  }
  // Inline function 'kotlin.math.min' call
  var a_0 = a - fromIdx | 0;
  var b_0 = b - a | 0;
  var s_0 = Math.min(a_0, b_0);
  vecSwap(_this__u8e3s4, fromIdx, b - s_0 | 0, s_0);
  // Inline function 'kotlin.math.min' call
  var a_1 = d - c | 0;
  var b_1 = (toIdx - d | 0) - 1 | 0;
  s_0 = Math.min(a_1, b_1);
  vecSwap(_this__u8e3s4, b, toIdx - s_0 | 0, s_0);
  // Inline function 'kotlin.also' call
  var this_2 = b - a | 0;
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'com.github.quillraven.fleks.collection.quickSort.<anonymous>' call
  s_0 = this_2;
  if (this_2 > 1) {
    quickSort(_this__u8e3s4, fromIdx, fromIdx + s_0 | 0, comparator);
  }
  // Inline function 'kotlin.also' call
  var this_3 = d - c | 0;
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'com.github.quillraven.fleks.collection.quickSort.<anonymous>' call
  s_0 = this_3;
  if (this_3 > 1) {
    quickSort(_this__u8e3s4, toIdx - s_0 | 0, toIdx, comparator);
  }
}
function selectionSort(_this__u8e3s4, fromIdx, toIdx, comparator) {
  var inductionVariable = fromIdx;
  var last = toIdx - 1 | 0;
  if (inductionVariable < last)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var m = i;
      var inductionVariable_0 = i + 1 | 0;
      if (inductionVariable_0 < toIdx)
        do {
          var j = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          if (comparator.compare(_this__u8e3s4[j], _this__u8e3s4[m]) < 0) {
            m = j;
          }
        }
         while (inductionVariable_0 < toIdx);
      if (!(m === i)) {
        swap(_this__u8e3s4, i, m);
      }
    }
     while (inductionVariable < last);
}
function med3(_this__u8e3s4, idxA, idxB, idxC, comparator) {
  var ab = comparator.compare(_this__u8e3s4[idxA], _this__u8e3s4[idxB]);
  var ac = comparator.compare(_this__u8e3s4[idxA], _this__u8e3s4[idxC]);
  var bc = comparator.compare(_this__u8e3s4[idxB], _this__u8e3s4[idxC]);
  var tmp;
  if (ab < 0) {
    tmp = bc < 0 ? idxB : ac < 0 ? idxC : idxA;
  } else if (bc > 0) {
    tmp = idxB;
  } else if (ac > 0) {
    tmp = idxC;
  } else {
    tmp = idxA;
  }
  return tmp;
}
function swap(_this__u8e3s4, idxA, idxB) {
  var tmp = _this__u8e3s4[idxA];
  _this__u8e3s4[idxA] = _this__u8e3s4[idxB];
  _this__u8e3s4[idxB] = tmp;
}
function vecSwap(_this__u8e3s4, idxA, idxB, n) {
  var a = idxA;
  var b = idxB;
  var inductionVariable = 0;
  if (inductionVariable < n)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var _unary__edvuaz = a;
      a = _unary__edvuaz + 1 | 0;
      var _unary__edvuaz_0 = b;
      b = _unary__edvuaz_0 + 1 | 0;
      swap(_this__u8e3s4, _unary__edvuaz, _unary__edvuaz_0);
    }
     while (inductionVariable < n);
}
function compareEntity$lambda($compareFun, $world) {
  return function (entityA, entityB) {
    return $compareFun($world, entityA, entityB);
  };
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
function _get_$cachedSerializer__te6jhj($this) {
  return $this.n1t_1.w1();
}
function ComponentType$Companion$_anonymous__95jk5k() {
  var tmp = getKClass(ComponentType);
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return PolymorphicSerializer.qv(tmp, tmp$ret$2);
}
var Companion_instance_0;
function Companion_getInstance_0() {
  if (Companion_instance_0 === VOID)
    new Companion_0();
  return Companion_instance_0;
}
function entityTagOf() {
  return new entityTagOf$1();
}
function componentName($this) {
  return substringBefore(substringAfterLast(toString(getKClassFromExpression($this.i1u_1)), '.'), '$');
}
var Companion_instance_1;
function Companion_getInstance_1() {
  if (Companion_instance_1 === VOID)
    new Companion_1();
  return Companion_instance_1;
}
var $serializer_instance;
function $serializer_getInstance() {
  if ($serializer_instance === VOID)
    new $serializer();
  return $serializer_instance;
}
function EntityService$removeAll$lambda($this$forEach, it) {
  $this$forEach.o1u(it);
  return Unit_instance;
}
function IteratingSystem$Companion$EMPTY_COMPARATOR$lambda(_unused_var__etf5q3, _unused_var__etf5q3_0) {
  return 0;
}
var Companion_instance_2;
function Companion_getInstance_2() {
  if (Companion_instance_2 === VOID)
    new Companion_2();
  return Companion_instance_2;
}
var EachFrame_instance;
function EachFrame_getInstance() {
  return EachFrame_instance;
}
var Automatic_instance;
function Automatic_getInstance() {
  return Automatic_instance;
}
function updateAggregatedFamilyHooks($this, family) {
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var this_0 = $this.o20();
  var destination = ArrayList.z();
  var tmp0_iterator = this_0.b1();
  while (tmp0_iterator.c1()) {
    var element = tmp0_iterator.d1();
    // Inline function 'com.github.quillraven.fleks.World.updateAggregatedFamilyHooks.<anonymous>' call
    var tmp;
    var tmp_0;
    if (element instanceof IteratingSystem) {
      tmp_0 = isInterface(element, FamilyOnAdd);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = element.o1z_1.equals(family);
    } else {
      tmp = false;
    }
    if (tmp) {
      destination.h(element);
    }
  }
  var addSystems = destination;
  var ownAddHook = $this.d1u_1.e3(family);
  var tmp_1 = family;
  var tmp_2;
  if (!(ownAddHook == null)) {
    tmp_2 = World$updateAggregatedFamilyHooks$lambda(ownAddHook, addSystems);
  } else {
    tmp_2 = World$updateAggregatedFamilyHooks$lambda_0(addSystems);
  }
  tmp_1.i1w_1 = tmp_2;
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var this_1 = $this.o20();
  var destination_0 = ArrayList.z();
  var tmp0_iterator_0 = this_1.b1();
  while (tmp0_iterator_0.c1()) {
    var element_0 = tmp0_iterator_0.d1();
    // Inline function 'com.github.quillraven.fleks.World.updateAggregatedFamilyHooks.<anonymous>' call
    var tmp_3;
    var tmp_4;
    if (element_0 instanceof IteratingSystem) {
      tmp_4 = isInterface(element_0, FamilyOnRemove);
    } else {
      tmp_4 = false;
    }
    if (tmp_4) {
      tmp_3 = element_0.o1z_1.equals(family);
    } else {
      tmp_3 = false;
    }
    if (tmp_3) {
      destination_0.h(element_0);
    }
  }
  var removeSystems = destination_0;
  var ownRemoveHook = $this.e1u_1.e3(family);
  var tmp_5 = family;
  var tmp_6;
  if (!(ownRemoveHook == null)) {
    tmp_6 = World$updateAggregatedFamilyHooks$lambda_1(removeSystems, ownRemoveHook);
  } else {
    tmp_6 = World$updateAggregatedFamilyHooks$lambda_2(removeSystems);
  }
  tmp_5.j1w_1 = tmp_6;
}
var Companion_instance_3;
function Companion_getInstance_3() {
  return Companion_instance_3;
}
function World$family$lambda($family) {
  return function ($this$forEach, it) {
    $family._v.p1w(it, $this$forEach.a1u_1.o1v_1.h1(it.m1u_1));
    return Unit_instance;
  };
}
function World$snapshot$lambda($result) {
  return function ($this$forEach, it) {
    var this_0 = $result;
    var value = $this$forEach.q20(it);
    this_0.k3(it, value);
    return Unit_instance;
  };
}
function World$updateAggregatedFamilyHooks$lambda($ownAddHook, $addSystems) {
  return function (_this__u8e3s4, entity) {
    $ownAddHook(_this__u8e3s4, entity);
    var tmp0_iterator = $addSystems.b1();
    while (tmp0_iterator.c1()) {
      var element = tmp0_iterator.d1();
      // Inline function 'com.github.quillraven.fleks.World.updateAggregatedFamilyHooks.<anonymous>.<anonymous>' call
      (isInterface(element, FamilyOnAdd) ? element : THROW_CCE()).m20(entity);
    }
    return Unit_instance;
  };
}
function World$updateAggregatedFamilyHooks$lambda_0($addSystems) {
  return function (_this__u8e3s4, entity) {
    var tmp0_iterator = $addSystems.b1();
    while (tmp0_iterator.c1()) {
      var element = tmp0_iterator.d1();
      // Inline function 'com.github.quillraven.fleks.World.updateAggregatedFamilyHooks.<anonymous>.<anonymous>' call
      (isInterface(element, FamilyOnAdd) ? element : THROW_CCE()).m20(entity);
    }
    return Unit_instance;
  };
}
function World$updateAggregatedFamilyHooks$lambda_1($removeSystems, $ownRemoveHook) {
  return function (_this__u8e3s4, entity) {
    var this_0 = $removeSystems;
    var lastIndex = get_lastIndex(this_0);
    var inductionVariable = lastIndex;
    var tmp;
    if (0 <= inductionVariable) {
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + -1 | 0;
        // Inline function 'com.github.quillraven.fleks.World.updateAggregatedFamilyHooks.<anonymous>.<anonymous>' call
        var it = this_0.h1(i);
        (isInterface(it, FamilyOnRemove) ? it : THROW_CCE()).n20(entity);
      }
       while (0 <= inductionVariable);
      tmp = Unit_instance;
    }
    $ownRemoveHook(_this__u8e3s4, entity);
    return Unit_instance;
  };
}
function World$updateAggregatedFamilyHooks$lambda_2($removeSystems) {
  return function (_this__u8e3s4, entity) {
    var this_0 = $removeSystems;
    var lastIndex = get_lastIndex(this_0);
    var inductionVariable = lastIndex;
    var tmp;
    if (0 <= inductionVariable) {
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + -1 | 0;
        // Inline function 'com.github.quillraven.fleks.World.updateAggregatedFamilyHooks.<anonymous>.<anonymous>' call
        var it = this_0.h1(i);
        (isInterface(it, FamilyOnRemove) ? it : THROW_CCE()).n20(entity);
      }
       while (0 <= inductionVariable);
      tmp = Unit_instance;
    }
    return Unit_instance;
  };
}
var Companion_instance_4;
function Companion_getInstance_4() {
  if (Companion_instance_4 === VOID)
    new Companion_4();
  return Companion_instance_4;
}
var $serializer_instance_0;
function $serializer_getInstance_0() {
  if ($serializer_instance_0 === VOID)
    new $serializer_0();
  return $serializer_instance_0;
}
function wildcardSnapshotOf(components, tags) {
  var tmp = isInterface(components, KtList) ? components : THROW_CCE();
  return new Snapshot(tmp, isInterface(tags, KtList) ? tags : THROW_CCE());
}
function configureWorld(entityCapacity, cfg) {
  entityCapacity = entityCapacity === VOID ? 512 : entityCapacity;
  var newWorld = World.r20(entityCapacity);
  Companion_instance_3.e1t_1 = newWorld;
  try {
    // Inline function 'kotlin.apply' call
    var this_0 = new WorldConfiguration(newWorld);
    // Inline function 'kotlin.contracts.contract' call
    cfg(this_0);
    this_0.f21();
  }finally {
    Companion_instance_3.e1t_1 = null;
  }
  return newWorld;
}
//region block: post-declaration
initMetadataForClass(Bag, 'Bag');
initMetadataForClass(BitArray, 'BitArray', BitArray);
initMetadataForClass(MutableEntityBag, 'MutableEntityBag', MutableEntityBag);
initMetadataForClass(sam$kotlin_Comparator$0, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForCompanion(Companion);
initMetadataForInterface(UniqueId, 'UniqueId');
initMetadataForCompanion(Companion_0, VOID, [SerializerFactory]);
initMetadataForClass(ComponentType, 'ComponentType', VOID, VOID, [UniqueId], VOID, VOID, {0: Companion_getInstance_0});
initMetadataForInterface(Component, 'Component');
initMetadataForClass(ComponentService, 'ComponentService', ComponentService);
initMetadataForClass(ComponentsHolder, 'ComponentsHolder');
initMetadataForClass(entityTagOf$1);
initMetadataForCompanion(Companion_1);
protoOf($serializer).e17 = typeParametersSerializers;
initMetadataForObject($serializer, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(Entity, 'Entity', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance});
initMetadataForClass(EntityComponentContext, 'EntityComponentContext');
initMetadataForClass(EntityCreateContext, 'EntityCreateContext');
initMetadataForClass(EntityUpdateContext, 'EntityUpdateContext');
initMetadataForClass(EntityService, 'EntityService');
initMetadataForClass(DefaultEntityProvider, 'DefaultEntityProvider');
initMetadataForClass(FleksException, 'FleksException');
initMetadataForClass(FleksNoSuchInjectableException, 'FleksNoSuchInjectableException');
initMetadataForClass(FleksNoSuchSystemException, 'FleksNoSuchSystemException');
initMetadataForClass(FleksSystemAlreadyAddedException, 'FleksSystemAlreadyAddedException');
initMetadataForClass(FleksFamilyException, 'FleksFamilyException');
initMetadataForClass(FleksSnapshotException, 'FleksSnapshotException');
initMetadataForClass(FleksWrongSystemInterfaceException, 'FleksWrongSystemInterfaceException');
initMetadataForClass(FleksWrongConfigurationUsageException, 'FleksWrongConfigurationUsageException', FleksWrongConfigurationUsageException.j1t);
initMetadataForClass(FleksNoSuchEntityComponentException, 'FleksNoSuchEntityComponentException');
initMetadataForClass(FleksWorldModificationDuringConfigurationException, 'FleksWorldModificationDuringConfigurationException', FleksWorldModificationDuringConfigurationException.n1y);
initMetadataForClass(FleksInjectableAlreadyAddedException, 'FleksInjectableAlreadyAddedException');
initMetadataForClass(Family, 'Family');
initMetadataForClass(FamilyDefinition, 'FamilyDefinition', FamilyDefinition);
initMetadataForClass(sam$kotlin_Comparator$0_0, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForCompanion(Companion_2);
initMetadataForClass(IntervalSystem, 'IntervalSystem');
initMetadataForClass(IteratingSystem, 'IteratingSystem');
initMetadataForObject(EachFrame, 'EachFrame');
initMetadataForClass(Fixed, 'Fixed');
initMetadataForInterface(FamilyOnAdd, 'FamilyOnAdd');
initMetadataForInterface(FamilyOnRemove, 'FamilyOnRemove');
initMetadataForObject(Automatic, 'Automatic');
initMetadataForCompanion(Companion_3);
initMetadataForClass(World, 'World');
initMetadataForCompanion(Companion_4);
protoOf($serializer_0).e17 = typeParametersSerializers;
initMetadataForObject($serializer_0, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(Snapshot, 'Snapshot', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_0});
initMetadataForClass(WorldConfiguration, 'WorldConfiguration');
initMetadataForClass(InjectableConfiguration, 'InjectableConfiguration');
initMetadataForClass(FamilyConfiguration, 'FamilyConfiguration');
initMetadataForClass(SystemConfiguration, 'SystemConfiguration');
initMetadataForClass(Injectable, 'Injectable');
//endregion
//region block: init
Companion_instance = new Companion();
EachFrame_instance = new EachFrame();
Automatic_instance = new Automatic();
Companion_instance_3 = new Companion_3();
//endregion
//region block: exports
export {
  BitArray as BitArraytmxppw7kahiv,
  compareEntity as compareEntity3htp4uiiyzpay,
  onAdd as onAdd3w32ndo60fp45,
  onRemove as onRemove1dlc2ri522bcn,
  ComponentType as ComponentTypexyjrw68h3mkw,
  ComponentsHolder as ComponentsHolder3q340rvi7bl8z,
  Component as Component2zk71ruxtvbyc,
  Entity as Entityn8ai25fppvib,
  Fixed as Fixed1qeb78bwjzy3z,
  FleksNoSuchInjectableException as FleksNoSuchInjectableException38hdhcbiqafml,
  FleksNoSuchSystemException as FleksNoSuchSystemException2ayar60lwtokj,
  IntervalSystem as IntervalSystemkg47nrqbxzr9,
  IteratingSystem as IteratingSystem3a6t5fwjqjqys,
  Snapshot as Snapshot20levc42dqnix,
  UniqueId as UniqueId1lkie4p3b7cfv,
  configureWorld as configureWorld2tcaoe751ploa,
  entityTagOf as entityTagOf37yyn22q9vdbj,
  wildcardSnapshotOf as wildcardSnapshotOfp6v73r7o9811,
  EachFrame_instance as EachFrame_instance3v9fuozm77djs,
  $serializer_getInstance as $serializer_getInstance1csrkprdkpiwp,
  Companion_getInstance_1 as Companion_getInstancecux5rh543dlh,
  Companion_instance_3 as Companion_instance30dlkjl07rtbp,
};
//endregion
